import React from "react";
import { Link } from "react-router-dom";

const Succeeded = () => {
  return (
    <>
      <p>Your password was successfully reset.</p>
      <Link to="/">Go back to Login</Link>
    </>
  );
};

export default Succeeded;
